export const UPDATE_ALLDATA = 'UPDATE_ALLDATA';
export const UPDATE_OVERALL = 'UPDATE_OVERALL';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_SUGGESTION = 'UPDATE_SUGGESTION';
export const UPDATE_CONJUNCTION = 'UPDATE_CONJUNCTION';
export const UPDATE_PHRASES = 'UPDATE_PHRASES';
export const UPDATE_CLAUSE = 'UPDATE_CLAUSE';
